<template>
  <div class="member-vehicles-wrap">
    <PremiumTable
      title="Vehicles"
      :columns="columns"
      :items="vehicles"
      :loading="loading"
      :total-items="totalItems"
      :page.sync="page"
      :items-per-page.sync="itemsPerPage"
      :searchable="false"
    >
      <!-- Vehicle Name with type icon -->
      <template #col-vehicle_name="{ item }">
        <div class="vehicle-name-cell">
          <v-icon size="15" :class="vehicleTypeClass(item.vehicle_type)" class="vtype-icon">
            {{ vehicleTypeIcon(item.vehicle_type) }}
          </v-icon>
          <span class="vehicle-name">{{ item.vehicle_name || '—' }}</span>
        </div>
      </template>

      <!-- Registration Number -->
      <template #col-registration_number="{ item }">
        <span class="reg-num">{{ item.registration_number }}</span>
      </template>

      <!-- Parking -->
      <template #col-parking_allocation="{ item }">
        <span
          class="parking-pill"
          :class="item.parking_allocation === 2 ? 'parking-reserved' : 'parking-open'"
        >
          <v-icon size="12" class="mr-1">
            {{ item.parking_allocation === 2 ? 'mdi-parking' : 'mdi-map-marker-outline' }}
          </v-icon>
          {{ item.parking_allocation === 2
              ? (item.parking_number || 'Reserved')
              : 'Open' }}
        </span>
      </template>
    </PremiumTable>
  </div>
</template>

<script>
import PremiumTable from '../../common/PremiumTable.vue';

const VEHICLE_TYPES = [
  { value: 1, label: 'Two-Wheeler',  icon: 'mdi-motorbike',   cls: 'type-two'   },
  { value: 2, label: 'Four-Wheeler', icon: 'mdi-car-outline', cls: 'type-four'  },
  { value: 3, label: 'Others',       icon: 'mdi-truck-outline', cls: 'type-other' },
];

export default {
  name: 'MemberVehicles',
  components: { PremiumTable },

  props: {
    unit_mapping_id: { type: [String, Number], required: true },
  },

  data() {
    return {
      loading: false,
      vehicles: [],
      totalItems: 0,
      page: 1,
      itemsPerPage: 10,
      columns: [
        { key: 'vehicle_name',        label: 'Vehicle',     width: '200px' },
        { key: 'registration_number', label: 'Reg. No.',    width: '160px' },
        { key: 'parking_allocation',  label: 'Parking',     width: '160px' },
      ],
    };
  },

  watch: {
    page()        { this.fetchVehicles(); },
    itemsPerPage(){ this.page = 1; this.fetchVehicles(); },
    unit_mapping_id(val) { if (val) this.fetchVehicles(); },
  },

  mounted() {
    if (this.unit_mapping_id) this.fetchVehicles();
  },

  methods: {
    async fetchVehicles() {
      this.loading = true;
      try {
        const res = await this.$axios.get(
          `societyadmin/members/${this.unit_mapping_id}/vehicles`,
          { params: { page: this.page, perPage: this.itemsPerPage } }
        );
        if (res.data.status) {
          this.vehicles   = res.data.vehicles  || [];
          this.totalItems = res.data.total     || 0;
        }
      } catch (e) {
        console.error('[MemberVehicles] fetch error', e);
      } finally {
        this.loading = false;
      }
    },

    vehicleTypeIcon(type) {
      return VEHICLE_TYPES.find(t => t.value === type)?.icon || 'mdi-car-outline';
    },
    vehicleTypeClass(type) {
      return VEHICLE_TYPES.find(t => t.value === type)?.cls || 'type-other';
    },
  },
};
</script>

<style scoped>
.member-vehicles-wrap { min-height: 200px; }

/* Vehicle name cell */
.vehicle-name-cell {
  display: flex;
  align-items: center;
  gap: 7px;
}
.vtype-icon { flex-shrink: 0; }
.vtype-icon.type-two   { color: #059669; }
.vtype-icon.type-four  { color: #2563eb; }
.vtype-icon.type-other { color: #7c3aed; }
.vehicle-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--tx);
}

/* Registration number */
.reg-num {
  font-size: 12.5px;
  font-weight: 700;
  font-family: 'JetBrains Mono', monospace;
  color: var(--tx2);
  letter-spacing: 0.05em;
}

/* Parking pill */
.parking-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
}
.parking-open {
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
  border: 1px solid rgba(16, 185, 129, 0.2);
}
.parking-reserved {
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
  border: 1px solid rgba(245, 158, 11, 0.2);
}
</style>
